export * from './post-kunden-gruppe-request.interface';
export * from './post-kunden-gruppe-response.interface';
export * from './post-kunden-gruppe.shapes';
